import { render } from "./ComponentSkill.vue?vue&type=template&id=1a81da18"
import script from "./ComponentSkill.vue?vue&type=script&lang=js"
export * from "./ComponentSkill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__